import type { Locale } from '@/i18n'

import type { AuthorDirectorySearchEntry } from './types'

const normalizeSearchText = (value: string, locale: Locale): string =>
  value.normalize('NFKD').replace(/\p{M}/gu, '').toLocaleLowerCase(locale).trim()

export const filterAuthorsByName = <Author extends Pick<AuthorDirectorySearchEntry, 'name'>>(
  authors: Author[],
  query: string,
  locale: Locale
): Author[] => {
  const terms = normalizeSearchText(query, locale).split(/\s+/).filter(Boolean)
  if (terms.length === 0) return authors

  return authors.filter((author) => {
    const name = normalizeSearchText(author.name, locale)
    return terms.every((term) => name.includes(term))
  })
}
